import { Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CartItem, CartService } from '../../../../services/cart.service';
import { DOMHandlerService } from '../../../../services/domhandler.service';
import { CustomPricePipe } from '../../../../pipes/price.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageService } from '../../../../services/language.service';
import { CustomDatePipe } from '../../../../pipes/date.pipe';
import { SharedNgxskeletonloaderModule } from '../../../../services/ngxskeletonloader.module';

@Component({
    selector: 'app-cart-item',
    imports: [
        RouterLink,
        CustomPricePipe,
        TranslatePipe,
        CustomDatePipe,
        SharedNgxskeletonloaderModule,
    ],
    templateUrl: './cart-item.component.html',
})
export class CartItemComponent {
    item = input.required<CartItem>();
    cartService = inject(CartService);
    languageService = inject(LanguageService);
    domhandler = inject(DOMHandlerService);
}
